import React from "react";
import { Select, Button } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import trans from "../../../../utils";

const OPERATORS = [
	{ label: "+", value: "add" },
	{ label: "-", value: "subtract" },
	{ label: "×", value: "multiply" },
	{ label: "÷", value: "divide" },
	{ label: trans("Sum"), value: "sum" },
	{ label: trans("Product"), value: "product" },
	{ label: trans("Min"), value: "min" },
	{ label: trans("Max"), value: "max" },
	{ label: trans("Average"), value: "avg" },
];

export default function FormOptionComputed({ activeItem, siblingFields, updateActiveItem }) {
	const config = activeItem?.computedConfig || {};
	const operands = Array.isArray(config.operands) ? config.operands : [];

	const operandOptions = siblingFields
		.filter(
			(f) =>
					(f.name === "Input" && f.inputType === "number") ||
					f.name === "DerivedValue" ||
				f.name === "ComputedValue"
		)
		.map((f) => ({ label: f.title || f.key, value: f.key }));

	const updateOperands = (operands) => {
		updateActiveItem("computedConfig.operands", operands);
	};

	const addOperand = () => {
		updateOperands([...operands, null]);
	};

	const removeOperand = (idx) => {
		const next = [...operands];
		next.splice(idx, 1);
		updateOperands(next);
	};

	const updateOperand = (idx, value) => {
		const next = [...operands];
		next[idx] = value;
		updateOperands(next);
	};

	return (
		<div className="field-settings-section">
			<h5 className="field-settings-section-title">{trans("Computed Value Configuration")}</h5>

			<div className="field-settings-control">
				<label className="form-label">{trans("Operator")}</label>
				<Select
					style={{ width: "100%" }}
					value={config.operator || undefined}
					options={OPERATORS}
					onChange={(v) => updateActiveItem("computedConfig.operator", v)}
				/>
			</div>

			<div className="field-settings-control">
				<label className="form-label">{trans("Operands")}</label>
				{operands.map((operand, idx) => (
					<div key={idx} className="field-settings-list-row">
						<Select
							style={{ flex: 1 }}
							value={operand}
							options={operandOptions}
							onChange={(v) => updateOperand(idx, v)}
							placeholder={trans("Select field")}
							allowClear
						/>
						<Button
							className="field-settings-icon-button"
							icon={<CloseCircleOutlined />}
							onClick={() => removeOperand(idx)}
							danger
							type="text"
						/>
					</div>
				))}
				<Button onClick={addOperand} type="dashed" block>
					{trans("Add Operand")}
				</Button>
			</div>
		</div>
	);
}
